import { LOAD_SERVICE_FAVORITE_STATUS } from '../constants';
import { getFavoriteStatus } from '../../resources/index';
import { loadServiceFavoriteStatusSuccess } from '../favorite/actions';

const loadServiceFavoriteStatusMiddleware = ({
  dispatch
}) => next => action => {
  const { type } = action;

  if (type !== LOAD_SERVICE_FAVORITE_STATUS) {
    return next(action);
  }

  getFavoriteStatus().then(response => {
    const { data } = response;
    dispatch(loadServiceFavoriteStatusSuccess(data.in_favorites));
  });

  return next(action);
};

export default loadServiceFavoriteStatusMiddleware;
